import {PlanType} from '@product-web/api/types/plan'
import {getIsCompanyOwner, useUser} from '@product-web/shell/user'

import {useCompanySubscription} from '~/paywall/lib/company-subscription'

export const getMappedPlan = (): Record<string, PlanType> => ({
    [PlanType.ESSENTIAL]: PlanType.PRO,
    [PlanType.PRO]: PlanType.PRO,
    [PlanType.PREMIUM]: PlanType.PREMIUM,
    [PlanType.YEARLY]: PlanType.PREMIUM,
    [PlanType.LEGACY]: PlanType.PRO,
    [PlanType.EXTRA]: PlanType.PRO,
    [PlanType.YEARLY_EXTRA]: PlanType.PREMIUM,
    [PlanType.PARTNERSHIP]: PlanType.PRO,
    [PlanType.MANAGING_PARTNER]: PlanType.PREMIUM,
    [PlanType.MANAGING_PARTNER_5]: PlanType.PREMIUM,
    [PlanType.MANAGING_PARTNER_10]: PlanType.PREMIUM,
    [PlanType.MANAGING_PARTNER_15]: PlanType.PREMIUM,
    [PlanType.MANAGING_PARTNER_20]: PlanType.PREMIUM,
    [PlanType.MANAGING_PARTNER_25]: PlanType.PREMIUM,
    [PlanType.PARTNER_CLIENT_FREE]: PlanType.FREE,
    [PlanType.PARTNER_CLIENT_PRO]: PlanType.PRO,
    [PlanType.UNKNOWN]: PlanType.PRO,
    [PlanType.FREE]: PlanType.FREE,
    [PlanType.STARTER]: PlanType.STARTER,
    [PlanType.FIXED_RATE]: PlanType.FIXED_RATE,
    [PlanType.TEAM]: PlanType.TEAM,
    [PlanType.BUSINESS]: PlanType.BUSINESS,
    [PlanType.ADVANCED]: PlanType.ADVANCED,
    [PlanType.INSURANCE]: PlanType.INSURANCE,
})

export default function useShouldPromoCardBeVisible(): boolean {
    const user = useUser()
    const isCompanyOwner = getIsCompanyOwner(user)
    const {data: subscription} = useCompanySubscription()
    const planMapping = getMappedPlan()
    const planType = subscription?.platformRatePlan.type
    const mappedPlanType = planType && planMapping[planType]
    const isStarterPlan =
        mappedPlanType && [PlanType.FREE, PlanType.STARTER].includes(mappedPlanType)

    return isCompanyOwner && !!isStarterPlan && !subscription?.isInTrialPeriod
}
